import { cn } from '../../lib/utils';

export default function PageHeader({
  eyebrow,
  title,
  description,
  meta,
  actions,
  className
}) {
  return (
    <div className={cn('flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between', className)}>
      <div className="min-w-0">
        {eyebrow && (
          <div className="mb-2 text-xs font-semibold uppercase tracking-wide text-blue-700">
            {eyebrow}
          </div>
        )}
        <h1 className="text-2xl font-semibold tracking-normal text-slate-950">
          {title}
        </h1>
        {description && (
          <p className="mt-1 max-w-3xl text-sm text-slate-600">
            {description}
          </p>
        )}
        {meta && (
          <p className="mt-2 text-xs text-slate-500">
            {meta}
          </p>
        )}
      </div>
      {actions && (
        <div className="flex shrink-0 flex-wrap items-center gap-2">
          {actions}
        </div>
      )}
    </div>
  );
}
